<template>
  <v-app-bar
      class="responsive-foot"
      :class="$mq"
      elevation="0"
      :prominent="$mq == 'smartphone'"
  >
    <v-col>
      <v-row class="text-center">
        <div class="text-footer" :class="$mq">
          <div>{{ $t("footer.title") }}</div>
          <div v-if="$mq === 'computer'">&nbsp;-&nbsp;</div>
          <div>{{ $t("footer.rights") }}</div>
          <div v-if="$mq === 'computer'">&nbsp;-&nbsp;</div>
          <div>{{ $t("footer.date") }}</div>
        </div>
      </v-row>
      <v-row class="text-center">
        <div>
          <a :href="this.mentions_legales">{{ $t("footer.legal")}}</a>
        </div>
      </v-row>
    </v-col>
  </v-app-bar>
</template>

<script>
export default {
  name: "footerTest",

  data() {
    return {
      date: new Date(),
      mentions_legales: process.env.VUE_APP_MENTIONS_LEGALES,
    }
  },
}
</script>

<style lang="scss">
@import "../utilities/variables";

.text-footer.computer {
  display: flex;
}

.text-footer.smartphone {
  display: flex;
  flex-direction: column;
}

.responsive-foot.computer {
  position: relative;
  bottom: 0;
  height: $footer-height;
  width: 100%;

  background-color: $item-background-color;
  border-top: 1px solid;
  border-top-color: darken(#e8eff9,15%) !important;
  color: $text-color;

  font-size: 0.875rem;
}

.responsive-foot.smartphone {
  position: relative;
  bottom: 0;
  height: $footer-phone-height;
  width: 100%;

  background-color: $item-background-color;
  border-top: 1px solid;
  border-top-color: darken(#e8eff9,15%) !important;
  color: $text-color;

  font-size: 0.875rem;
}

.text-center {
  display: flex;
  justify-content: center;
  font-family: 'Unistra A';
  font-size: 1.20rem;
  text-align: center;
}
</style>
